import React from 'react'
// components
import Grid from '@mui/material/Grid2'
import { AvatarsList } from 'components/UI'
// constants
import { REVIEW_STATUSES } from 'constants/review'
// views
import {
  AvatarWrapper,
  DueDateWrapper,
  DueIndicator,
  InfoWrapper,
  ProgressIndicator,
  ReviewIcon,
  TextSeparator,
  Wrapper
} from 'components/Modals/PlanItems/components/CompleteReview/views'
// utils
import get from 'lodash/get'
import moment from 'moment'
import { getReviewDueInfo } from 'utils/reviews'

interface IIncomingProps {
  review: any
  isFullModal?: boolean
  isSidebar?: boolean
  // hides the DUE TODAY / OVERDUE label
  hideDueIndicator?: boolean
  // the action on the right side of the bar
  children?: React.ReactNode
}

// The review summary bar of a plan item: due date, status, reviewers
const ReviewBar: React.FunctionComponent<IIncomingProps> = ({
  review,
  isFullModal,
  isSidebar,
  hideDueIndicator,
  children
}) => {
  const reviewers = get(review, 'scheduledReview.scheduledReviewers')
  const reviewStatus = get(review, 'status', REVIEW_STATUSES.NOT_STARTED)

  const { isDueToday, isOverdue } = getReviewDueInfo(review)

  const avatarsLimit = isSidebar ? 2 : isFullModal ? 5 : 8

  return (
    <Wrapper $isSidebar={isSidebar} $isFullModal={isFullModal}>
      <ReviewIcon />
      <InfoWrapper container>
        <DueDateWrapper>{`Review due ${moment(review.dueDate).format('D MMM YYYY')}`}</DueDateWrapper>
        <Grid container>
          <ProgressIndicator>{reviewStatus.replace('_', ' ')}</ProgressIndicator>
          {!hideDueIndicator && (isDueToday || isOverdue) && (
            <>
              <TextSeparator>|</TextSeparator>
              <DueIndicator isDueToday={isDueToday}>{isDueToday ? 'DUE TODAY' : 'OVERDUE'}</DueIndicator>
            </>
          )}
        </Grid>
      </InfoWrapper>
      <AvatarWrapper container>
        <AvatarsList list={reviewers} limit={avatarsLimit} />
      </AvatarWrapper>
      {children}
    </Wrapper>
  )
}

export default ReviewBar
